import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';


@Injectable({
  providedIn: 'root',
})
export class AppInitService {
  constructor(private authService: AuthService) {}

  initializeApp(): Promise<void> {
    return new Promise((resolve) => {

      this.authService.requestAuthorization().subscribe({
        next: (response) => {

          sessionStorage.setItem('authToken', response.access_token);
          resolve(); // Indica que la inicialización ha terminado
        },
        error: (err) => {

          resolve(); // Continuar con la aplicación aunque haya error
        },
      });
    });
  }
}
